<mat-card class="issueTmp" fxLayout="row" fxLayoutGap="5">
    <!-- Checkbox -->
    <mat-checkbox #checkbox fxFlex="30" fxLayoutAlign=" center" (change)='onCheckboxChange($event)' color='primary'
        [disabled]="mode === 'read'">Issue template </mat-checkbox>
    <!-- Issue template select dropdown -->
    <mat-form-field fxFlex="65">
        <mat-label>Issue templates</mat-label>
        <mat-select #issueTmpSelect (selectionChange)="onDropdownSelect($event)"
            [disabled]="mode === 'read' || !checkboxValue"
            [placeholder]="issueTmplList.length === 0 ? 'No issue templates available' : ''">
            <mat-option *ngFor="let option of issueTmplList" [value]="option.id">
                {{ option.file_nm || option }}
            </mat-option>
        </mat-select>
    </mat-form-field>
</mat-card>